import { createAction } from 'redux-actions';

export const authVerifyPhoneNumberRequest = createAction('AUTH_VERIFY_PHONE_NUMBER_REQUEST');
export const authVerifyPhoneNumberSuccess = createAction('AUTH_VERIFY_PHONE_NUMBER_SUCCESS');
export const authVerifyPhoneNumberFail = createAction('AUTH_VERIFY_PHONE_NUMBER_FAIL');
